import { tsUtils } from '@neo-one/ts-utils';
export const hasNull = (_context, _node, type) => tsUtils.type_.hasNull(type);
export const isOnlyNull = (_context, _node, type) => tsUtils.type_.isOnlyNull(type);
export const isNull = (_context, _node, type) => tsUtils.type_.isNull(type);

//# sourceMappingURL=typeTests.js.map
